import { redirect, createFileRoute } from '@tanstack/react-router';

/** Tasks is what a customer opens the service for, so `/white-glove` is it. */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/white-glove/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/o/$orgId/c/$clientId/white-glove/tasks',
      params,
    });
  },
});
